import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-un-secolo-di-storia',
  templateUrl: './un-secolo-di-storia.component.html',
  styleUrls: ['./un-secolo-di-storia.component.scss']
})
export class UnSecoloDiStoriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
